import React, { useState } from 'react';
import { useToast } from '../../hooks/useToast';
import settingsService from '../../services/settings.service';

interface EmailTestPanelProps {
  testModeOn: boolean;
  disabled?: boolean;
  /** Whether EMAIL_TEST_MODE has an unsaved edit staged in the form above. */
  pendingChange?: boolean;
}

const EmailTestPanel: React.FC<EmailTestPanelProps> = ({ testModeOn, disabled, pendingChange }) => {
  const [sending, setSending] = useState(false);
  const toast = useToast();

  const handleSend = async () => {
    try {
      setSending(true);
      const result = await settingsService.sendTestEmail();
      toast.success(
        result.test_mode
          ? `Test email sent to ${result.recipient} — view it in Mailpit`
          : `Test email sent to ${result.recipient} via SMTP`,
      );
    } catch (error: any) {
      toast.error(error?.response?.data?.error || 'Failed to send test email');
    } finally {
      setSending(false);
    }
  };

  return (
    <div className="mt-4 border-t border-rule-faint pt-3">
      {testModeOn && (
        <p className="mb-2 text-scale-1 text-ink-muted">
          Mail test mode is ON — all outbound email is captured in{' '}
          <a
            href="/mailpit/"
            target="_blank"
            rel="noopener noreferrer"
            className="text-accent underline"
          >
            Mailpit
            <span className="sr-only"> (opens in new tab)</span>
          </a>{' '}
          and none is delivered to real recipients.
        </p>
      )}
      {pendingChange && (
        <p className="mb-2 text-scale-1 italic text-ink-muted">
          A change to this setting is staged but not saved yet.
        </p>
      )}
      <button
        type="button"
        onClick={handleSend}
        disabled={disabled || sending}
        className="cursor-pointer border border-ink px-3 py-1.5 text-scale-1 text-ink hover:bg-paper-raised disabled:cursor-default disabled:opacity-60"
      >
        {sending ? 'Sending…' : 'Send test email'}
      </button>
    </div>
  );
};

export default EmailTestPanel;
